import React from 'react';
import { styled } from '@mui/material';
import { Card, Link, Stack, Text } from 'library/ui';

export default function ChatGuidelines() {
    return (
        <Card tone="muted" padding="sm">
            <Stack gap="sm">
                <Text size="sm" weight="semibold" tone="secondary">
                    BEFORE YOU CHAT
                </Text>
                <List>
                    <li>
                        <Text size="sm" lineHeight="relaxed">
                            Subs on your upcoming shifts schedule are confirmed. To remove a sub, go to{' '}
                            <Link to="/jobs" size="sm">
                                My Jobs
                            </Link>
                            .
                        </Text>
                    </li>
                    <li>
                        <Text size="sm" lineHeight="relaxed">
                            All shift changes must be made on{' '}
                            <Link to="/jobs" size="sm">
                                My Jobs
                            </Link>
                            , including booking, cancelling, and changing times.
                        </Text>
                    </li>
                    <li>
                        <Text size="sm" lineHeight="relaxed">
                            After a sub works 120 hours at your center, you can onboard them to your payroll.
                        </Text>
                    </li>
                </List>
            </Stack>
        </Card>
    );
}

const List = styled('ul')({
    margin: 0,
    paddingLeft: 20,
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
});
